import React from 'react';

const Sparkline = ({ 
  data = [], 
  width = 60, 
  height = 20, 
  color = '#0d9488',
  showTrend = true 
}) => {
  if (!data.length) return null;

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  
  const points = data.map((value, index) => {
    const x = (index / (data.length - 1)) * width;
    const y = height - ((value - min) / range) * height;
    return `${x},${y}`;
  }).join(' ');

  const isUpTrend = data[data.length - 1] > data[0];

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <svg width={width} height={height} style={{ display: 'block' }}>
        <polyline
          points={points}
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Optional dots for data points */}
        {data.map((value, index) => {
          const x = (index / (data.length - 1)) * width;
          const y = height - ((value - min) / range) * height;
          return (
            <circle
              key={index}
              cx={x}
              cy={y}
              r="1"
              fill={color}
              opacity={0.6}
            />
          );
        })}
      </svg>
      {showTrend && (
        <span style={{ 
          fontSize: '10px', 
          color: isUpTrend ? '#10b981' : '#ef4444',
          fontWeight: 600
        }}>
          {isUpTrend ? '↗' : '↘'}
        </span>
      )}
    </div>
  );
};

export default Sparkline;
